{
  "name": "@orcarail/node",
  "version": "3.3.0",
  "description": "Official Node.js SDK for OrcaRail - Accept crypto payments with Payment Intents",
  "main": "./dist/index.cjs",
  "module": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "import": {
        "types": "./dist/index.d.ts",
        "default": "./dist/index.js"
      },
      "require": {
        "types": "./dist/index.d.ts",
        "default": "./dist/index.cjs"
      }
    }
  },
  "files": [
    "dist",
    "README.md",
    "LICENSE"
  ],
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "test": "vitest run",
    "test:watch": "vitest",
    "lint": "eslint src tests examples --ext .ts",
    "format": "prettier --write \"src/**/*.ts\" \"tests/**/*.ts\" \"examples/**/*.ts\"",
    "typecheck": "tsc --noEmit",
    "prepublishOnly": "npm run build && npm test"
  },
  "keywords": [
    "orcarail",
    "crypto",
    "payments",
    "payment-intents",
    "webhooks",
    "blockchain",
    "stablecoin"
  ],
  "author": "OrcaRail",
  "license": "MIT",
  "publishConfig": {
    "access": "public"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/OrcaRail/sdks-node.git"
  },
  "bugs": {
    "url": "https://github.com/OrcaRail/sdks-node/issues"
  },
  "homepage": "https://github.com/OrcaRail/sdks-node#readme",
  "engines": {
    "node": ">=18.0.0"
  },
  "devDependencies": {
    "@types/express": "^5.0.6",
    "@types/node": "^20.0.0",
    "@typescript-eslint/eslint-plugin": "^6.0.0",
    "@typescript-eslint/parser": "^6.0.0",
    "eslint": "^8.0.0",
    "express": "^5.2.1",
    "next": "^16.2.4",
    "prettier": "^3.0.0",
    "tsup": "^8.0.0",
    "typescript": "^5.0.0",
    "vitest": "^1.0.0"
  },
  "peerDependencies": {
    "@types/express": "^4.17.0",
    "@types/node": "^18.0.0 || ^20.0.0"
  },
  "peerDependenciesMeta": {
    "@types/express": {
      "optional": true
    },
    "@types/node": {
      "optional": true
    }
  }
}
